export { default } from './LedgerDatePicker.vue'

export const isValidRange = (v) => {
  const parts = v.trim().split('~')
  const [start, end] = parts

  if (typeof end === 'undefined') {
    return true
  }

  return new Date(start) <= new Date(end)
}
